import { useMemo } from "react"

import type { TableStatConfig } from "types/tableStatPlot.types"
import type { TableStatPlotView, RecordType } from "types/dashboard.types"

import tableStatConfig from "./tableStat"

interface UseTableStatConfig {
  view: TableStatPlotView
  data: RecordType[]
}

export default function useTableStatConfig({ view, data }: UseTableStatConfig) {
  const config: TableStatConfig = useMemo(
    () => tableStatConfig({ view, data }),
    [view, data],
  )

  return config
}
